import {
  SponsorshipFormFields,
  SponsorshipFormResponse,
} from "~/types/account/account.types";

import { sendRequest } from "../clients/axios";

export const createSponsorCode = async (input: SponsorshipFormFields) => {
  const res = await sendRequest<SponsorshipFormFields, SponsorshipFormResponse>(
    {
      method: "post",
      url: "/user/create-sponsor-code",
      data: input,
    }
  );
  return res.data;
};
